export default function lerp(a: number, b: number, alpha: number): number {
  return a + (b - a) * alpha;
}